// cart drawer start
let cart_drawer = document.getElementById("sidebar-cart");
let cart_drawer_content = document.querySelector(
  '[data-armada-selector="cart-drawer-selector"] #drawer-cart-content'
);
let drawer_overlay = document.getElementById("drawer-overlay");
let cart_icon = document.querySelector("[data-action='open-cart-drawer']");
let close_cart_drawer = document.querySelector(
  '[data-action="close-drawer"][data-drawer-id="sidebar-cart"]'
);

const handleDrawerOpenChanges = (z, opacity, overflowElem, overflowVal) => {
  drawer_overlay.style.zIndex = z;
  drawer_overlay.style.opacity = opacity;
  overflowElem.style.overflow = overflowVal;
};
function openDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "false");
  handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
}
function closeDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "true");
  handleDrawerOpenChanges(-1, 0, document.body, "auto");
}
const keydownHandler = function (event) {
  if (event.key === "Escape" || event.keyCode === 27) {
    closeDrawer(event);
  }
};
const handleToggleDrawer = () => {
  if (cart_drawer.getAttribute("aria-hidden") == "true") {
    handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
  } else {
    handleDrawerOpenChanges(-1, 0, document.body, "auto");
  }
};
let safeAreaListenerAdded = false;
const fetchCartDrawer = (openDrawer) => {
  fetch("/?view=cart")
    .then((res) => res.text())
    .then((html) => {
      if(!window.location.href.includes("/cart"))
      cart_drawer_content.innerHTML = html;
      openDrawer && cart_drawer.setAttribute("aria-hidden", "false");
    });
};

document.addEventListener("keydown", keydownHandler, false);
cart_icon?.addEventListener("click", (e) => openDrawer(e));
close_cart_drawer?.addEventListener("click", (e) => closeDrawer(e));
!window.location.href.includes("/cart") && drawer_overlay.addEventListener("click", (e) => closeDrawer(e));
// cart drawer end

const isMobileDevice =
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

const onWindowLoad = () => {
  fetchCartDrawer();
};
window.addEventListener("load", onWindowLoad, { passive: true });

// footer show/hide footer navigation list
const footer_titles = document.getElementsByClassName(
  "footer__heading-container"
);
const footer_navigation_ul = document.getElementsByClassName(
  "footer__navigation-ul"
);
const footer_navigation_plus_icon =
  document.getElementsByClassName("footer__plus-icon");

let result;

for (let i = 0; i < footer_titles.length; i++) {
  for (let j = 0; j < footer_navigation_ul.length; j++) {
    let title = footer_titles[i];
    let ul = footer_navigation_ul[j];
    let icon = footer_navigation_plus_icon[i];

    if (title.id == ul.getAttribute("data-id")) {
      isMobileDevice &&
        title.addEventListener(
          "click",
          () => {
            if (ul.style.display == "block") {
              ul.style.display = "none";
              icon.style.transform = "rotate(0deg)";
            } else {
              ul.style.display = "block";
              icon.style.transform = "rotate(45deg)";
            }
          },
          { passive: true }
        );
    }
  }
}

// functions

// Cards stack carousel on about page - mobile
function Caroustack(params = {}) {
  // Select container and items
  const container = document.querySelector(
    params.container || ".start-images-container"
  );
  const items = document.querySelectorAll(
    (params.container || ".start-images-container") +
      " > " +
      (params.items || ".how-we-started-img")
  );

  // Transition variables
  let currentSlide = 0;
  let tempSlide = currentSlide;
  let nextSlide = Math.min(currentSlide + 1, items.length - 1);
  let delta = 0;
  let angle = 0;

  // Set item order
  items.forEach((item, index) => (item.style.zIndex = -index));
  items[currentSlide].classList.add("active");
  items[nextSlide].classList.add("next");

  function initScroll(event) {
    initialTouch = event.clientX;
    container.classList.add("sliding");
    container.addEventListener("pointermove", moveScroll);
  }

  function moveScroll(event) {
    delta = initialTouch - event.clientX;
    angle = delta / 100;
    scaling = 1 - Math.abs(delta) / 5000;

    let slide = tempSlide;
    tempSlide =
      delta < 0
        ? currentSlide === 0
          ? items.length - 1
          : Math.max(currentSlide - 1, 0)
        : currentSlide;

    if (tempSlide !== slide) {
      items[slide].style.transform = `none`;
    }

    items[
      tempSlide
    ].style.transform = `translateX(${-delta}px) rotate(${-angle}deg) scale(${scaling})`;
  }

  function endScroll(event) {
    container.removeEventListener("pointermove", moveScroll);
    container.classList.remove("sliding");
    items[tempSlide].style.transform = `none`;

    if (Math.abs(delta) < 50) return;

    items.forEach((item) => {
      item.classList.remove("active", "next");
    });

    currentSlide =
      delta > 0
        ? tempSlide == items.length - 1
          ? 0
          : Math.min(tempSlide + 1, items.length - 1)
        : tempSlide;
    items[currentSlide].classList.add("active");

    nextSlide = currentSlide == items.length - 1 ? 0 : currentSlide + 1;
    items[nextSlide].classList.add("next");
  }

  // Event listeners
  container.addEventListener("pointerdown", initScroll);
  container.addEventListener("pointerup", endScroll);
  container.addEventListener("pointercancel", endScroll);
}

// Instantiate Caroustack
if (window.location.href.includes("about-us-test")) Caroustack();

// Warranty Logic Start
// window.addEventListener("load", (event) => {
//   let warranty_check = document.getElementById("add-warranty");
//   if (
//     window.location.href.includes("/products/") &&
//     current_product.type.includes("sunglasses")
//   ) {
//     warranty_check.addEventListener("click", (e) => {
//       if (e.target.checked) {
//         localStorage.setItem(
//           "warrantySelected",
//           window.variantStrings.productId
//         );
//       } else {
//         localStorage.setItem("warrantySelected", e.target.checked);
//       }
//     });
//   }
// });

